var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { apiGetOneCategorySeminar } from '@/actions/CategoryActionsTs';
import ClientSeminarListView from '@/container/Seminar/List/ClientSeminarListView';
import { parseQueryString } from '@/helpers/common/QueryStringHelper';
import { propArrayShape } from '@/helpers/custom-prop-types';
import { useClientSeminarList } from '@/helpers/use/client_seminar/useClientSeminarList';
import { useSeminarAuth } from '@/helpers/use/client_seminar/useSeminarAuth';
import UserPreviewState from '@/helpers/user/UserPreviewState';
import { useSessionStorageAction } from '@/hooks/action/sessionStorage/useSessionStorageAction';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { usePopularList } from '@/hooks/pages/list/popular/usePopularList';
import { usePopularListColumnViewData, usePopularListProfessionalViewData, } from '@/hooks/pages/list/popular/usePopularListViewData';
import { useBoolState } from '@/hooks/state/useBoolState';
import { SESSION_STORAGE_KEY_CATEGORY_SEMINAR } from '@/utils/constants/storage/sessionStorageKey';
export const ClientSeminarList = (props) => {
    const { articleLinkListItems } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { pathname, search, state: locationState } = useLocation();
    const { formatQuery } = useMemo(() => parseQueryString(search, [
        { initial: null, name: 'previewId', type: 'integer' },
        { initial: null, name: 'theme', type: 'integer' },
        { initial: [], name: 'types', type: 'string_split' },
    ]), [search]);
    const { isGuestUser, isProfessionalUser, userType } = useSeminarAuth();
    // カテゴリ：コラム/DL資料
    const { data: storageData, fetchData: fetchCategory, hasInitialData: hasInitialCategory, isLoading: isLoadingSeminarCategories, } = useSessionStorageAction({
        apiAction: apiGetOneCategorySeminar,
        dispatch,
        sessionStorageKey: SESSION_STORAGE_KEY_CATEGORY_SEMINAR,
        unmountRef,
    });
    const { activeCategory, seminarCategories } = useMemo(() => {
        const categories = ((storageData === null || storageData === void 0 ? void 0 : storageData.seminar_categories) || []).map((category) => ({
            label: category.name,
            value: category.id,
        }));
        return {
            // 選択中のカテゴリ
            activeCategory: categories.find((theme) => theme.value === formatQuery.theme),
            // カテゴリ一覧
            seminarCategories: categories,
        };
    }, [storageData, formatQuery.theme]);
    // 一覧ページの表示
    const { hideDocumentModal, images, isShowDocumentModal, loading, onChangeDocumentImage, onChangeTypeFilter, onClickCategory, onClickDocument, onClickSearchResult, onLoadMoreSeminars, paging, } = useClientSeminarList({
        dispatch,
        locationState,
        unmountRef,
    });
    // 登録モーダル
    const { boolState: isShowRegistrationModal, changeFalse: hideRegistrationModal, changeTrue: showRegistrationModal, } = useBoolState();
    const { isLoadingPopularCase, isLoadingPopularColumn, isLoadingPopularProfessional, popularCases, popularConsultantListHasMoreLink, popularProfessionals, populars, } = usePopularList({
        dispatch,
        isGuestUser,
        isProfessionalUser,
        keyword: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.label,
        unmountRef,
    });
    // 週間ランキング
    const weeklyRankingList = usePopularListColumnViewData({ populars });
    // 人気のコンサルタント
    const popularConsultantList = usePopularListProfessionalViewData({
        items: popularProfessionals,
    });
    // カテゴリの読み込み
    useEffect(() => {
        if (hasInitialCategory) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchCategory();
        }))();
    }, [hasInitialCategory, fetchCategory]);
    return (_jsx(ClientSeminarListView, { activeCategory: activeCategory, articleLinkListItems: articleLinkListItems, formatQuery: formatQuery, hideDocumentModal: hideDocumentModal, hideRegistrationModal: hideRegistrationModal, images: images, isGuestUser: isGuestUser, isLoadingSeminarCategories: isLoadingSeminarCategories, isPreview: UserPreviewState.isPreview, isProfessionalUser: isProfessionalUser, isShowDocumentModal: isShowDocumentModal, isShowRegistrationModal: isShowRegistrationModal, loading: loading, onChangeDocumentImage: onChangeDocumentImage, onChangeTypeFilter: onChangeTypeFilter, onClickCategory: onClickCategory, onClickDocument: onClickDocument, onClickDocumentLink: userType === 'guest' ? showRegistrationModal : onClickDocument, onClickSearchResult: onClickSearchResult, onLoadMoreSeminars: onLoadMoreSeminars, paging: paging, pathname: pathname, popularArticlePageLoading: isLoadingPopularColumn, popularArticlePages: weeklyRankingList, PopularCaseLoading: isLoadingPopularCase, popularCases: popularCases, popularProfessionalLoading: isLoadingPopularProfessional, popularProfessionals: popularConsultantList, popularProfessionalsLink: popularConsultantListHasMoreLink, previewId: formatQuery.previewId, seminarCategories: seminarCategories, showRegistrationModal: showRegistrationModal, userType: userType }));
};
ClientSeminarList.propTypes = {
    articleLinkListItems: propArrayShape().isRequired,
};
